module.exports = __webpack_public_path__ + "img/10551386_S.5d6a70ab.png";